export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7987.571ac1a6.jpg";